
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import ProductsDropdown from "./ProductsDropdown";
import "../styles/NavBar.css";
import "../styles/ProductsDropdown.css";
import FindPumpsDropdown from "./FindPumpsDropdown";
import OwnersDropdown from "./OwnersDropdown";

function NavBar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleDropdownToggle = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };


  return (
    <>
      <header className="header">
        <div className="nav-container">
          <nav className="nav">
            {/* Logo Section */}
            <div className="nav-brand">
              <a href="/" className="site-title" onClick={closeDropdown}>
                <img 
                  src="/pentair-logo-web.svg"
                  className="logo"
                  alt="Pentair Logo"
                />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="nav-menu">
              <ul className="nav-list">
                <li className="nav-item dropdown">
                  <button 
                    className={`nav-link dropdown-trigger ${activeDropdown === 'products' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownToggle('products');
                    }}
                  >
                    <span>Products</span>
                    <svg className={`dropdown-arrow ${activeDropdown === 'products' ? 'rotated' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </li>
                
                <li className="nav-item dropdown">
                  <button
                    className={`nav-link dropdown-trigger ${activeDropdown === 'find-pumps' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownToggle('find-pumps');
                    }}
                  >
                    <span>Find Pumps</span>
                    <svg className={`dropdown-arrow ${activeDropdown === 'find-pumps' ? 'rotated' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.293 7.293a 1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </li>

                <li className="nav-item dropdown">
                  <button
                    className={`nav-link dropdown-trigger ${activeDropdown === 'owners' ? 'active' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDropdownToggle('owners');
                    }}
                  >
                    <span>Owners & Support</span>
                    <svg className={`dropdown-arrow ${activeDropdown === 'owners' ? 'rotated' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.293 7.293a 1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </li>
              </ul>
            </div>

            {/* Mobile Menu Button */}
            <button 
              className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </nav>

          {/* Mobile Navigation Menu - keep your existing mobile menu */}
        </div>
      </header>

      {/* Toyota Style Dropdown */}
      <ProductsDropdown activeDropdown={activeDropdown} />
      <FindPumpsDropdown activeDropdown={activeDropdown} />
      <OwnersDropdown activeDropdown={activeDropdown} />
    </>
  );
}

export default NavBar;